import { Component, OnInit, Input } from "@angular/core";
import { RLChat } from "./rlChat";
import { environment } from "../../../environments/environment";

declare var IsLiveChatAvailable;
declare var GetLiveChatHrefWithParameters;

@Component({
  selector: "live-chat",
  templateUrl: "./live-chat.component.html",
  styleUrls: ["./live-chat.component.scss"],
})
export class LiveChatComponent implements OnInit {
  @Input() rgpTenantId;

  chat: RLChat = {
    customChatJSFile: environment.rlChatFile,
    host: "Schoolzilla",
  };
  isLiveChatAvailable: boolean;
  getLiveChatHrefWithParameters: boolean;
  loading: boolean;

  constructor() {}

  ngOnInit() {
    this.loading = true;
    // we populate the chat object's customerId, host and customChatJSFile fields
    // others are optional
    this.chat.customerId = this.rgpTenantId;
    this.setUpLiveChat();
  }

  setUpLiveChat() {
    if (this.chat && this.chat.customChatJSFile) {
      if (
        document.querySelector(
          'script[src="' + this.chat.customChatJSFile + '"]'
        )
      ) {
        this.getChatLive();
      } else {
        this.loadScript(this.chat.customChatJSFile, () => this.getChatLive());
      }
    }
  }

  getChatLive(): void {
    /* confirm that the livechat script is loaded, which should contain a global function to
    // check availability, otherwise fail gracefully*/
    this.loading = false;
    this.isLiveChatAvailable =
      typeof IsLiveChatAvailable === "function" ? IsLiveChatAvailable() : false;
  }

  loadScript(url, callback) {
    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.onload = callback;
    script.onerror = callback;
    head.appendChild(script);
  }

  chatClick() {
    if (this.isLiveChatAvailable) {
      const windowArgs =
        "width=484,height=620,resizable,scrollbars=yes,status=0,toolbar=0,menubar=0,location=0";
      window.open(
        GetLiveChatHrefWithParameters(
          this.chat.host,
          this.chat.customerId,
          this.chat.userToken
        ),
        "",
        windowArgs
      );
    }
  }
}
